import { render, staticRenderFns } from "./OrderShipmentsList.vue?vue&type=template&id=14ce51e6&scoped=true"
import script from "./OrderShipmentsList.vue?vue&type=script&lang=js"
export * from "./OrderShipmentsList.vue?vue&type=script&lang=js"
import style0 from "./OrderShipmentsList.vue?vue&type=style&index=0&id=14ce51e6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ce51e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14ce51e6')) {
      api.createRecord('14ce51e6', component.options)
    } else {
      api.reload('14ce51e6', component.options)
    }
    module.hot.accept("./OrderShipmentsList.vue?vue&type=template&id=14ce51e6&scoped=true", function () {
      api.rerender('14ce51e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/AdminSummarySubs/OrderShipmentsList.vue"
export default component.exports